import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackUserChangePage } from '../../helper/utils/eventTrackGA';
import { trackMetaPageView } from '../../helper/utils/eventTrackMeta';

export default function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        trackUserChangePage(location.pathname);
        trackMetaPageView();
    }, [location.pathname]);

    return null;
}
